import { render, staticRenderFns } from "./image_lightbox.vue.js?vue&type=template&id=96b883ae!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=template&id=96b883ae"
import script from "./image_lightbox.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=script&lang=js"
export * from "./image_lightbox.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports